import Constants from './NewCovidConstant';

let initialState = {
    loadingCovid: true,
    errorCovid:{},
    CovidPackage:[]
};

export default function NewCovidReducer(state = initialState, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Constants.ACTIONS.GET_COVIDPACK_LOADING:
            newState.loading = true;
            break;
        case Constants.ACTIONS.GET_COVIDPACK:
            newState.CovidPackage = action.payload;
            newState.loadinglp = false;
            break;
        case Constants.ACTIONS.GET_COVIDPACK_FAIL:
            newState.errorCovid = action.payload;
            break;
        default:
            break;
    }
    return newState;
}